import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "text-secondary small mt-1" }
const _hoisted_3 = { class: "text-end" }
const _hoisted_4 = { class: "bg-light py-5 px-md-5 h-100 w-100 overflow-auto position-relative" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Vaše firmy", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Přehled firem za které lze vystavovat faktury", -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-6 mt-4" }
const _hoisted_10 = { class: "col-lg-6 mt-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "bi bi-plus-circle me-1",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, " Přidat novou firmu ", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Autocomplete = _resolveComponent("Autocomplete")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_SubmitButtonSm = _resolveComponent("SubmitButtonSm")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_LoadingOverlay = _resolveComponent("LoadingOverlay")!
  const _component_Company = _resolveComponent("Company")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.modalAddOpened)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "#modals"
        }, [
          _createVNode(_component_Modal, {
            title: "Přidat firmu",
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalAddOpened = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Form, {
                onSubmit: _ctx.onSubmit,
                "validation-schema": _ctx.schema
              }, {
                default: _withCtx(({ errors }) => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_Autocomplete, {
                      "search-handler": _ctx.searchHandler,
                      errors: errors,
                      name: "contact",
                      label: "Vyhledat název firmy"
                    }, null, 8, ["search-handler", "errors"]),
                    _createElementVNode("div", _hoisted_2, [
                      _createTextVNode(" Pokud firmu nemůžete nalézt, "),
                      _createVNode(_component_router_link, {
                        class: "link-secondary",
                        to: { name: 'Contacts', params: { page: 1 } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("je potřeba ji přidat do kontaktů ")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" . ")
                    ])
                  ]),
                  _createVNode(_component_Alert, {
                    data: _ctx.alert,
                    class: "mb-4"
                  }, null, 8, ["data"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalAddOpened = false)),
                      class: "btn btn-outline-secondary me-3"
                    }, "Zavřít"),
                    _createVNode(_component_SubmitButtonSm, {
                      loading: _ctx.modalBtnLoading,
                      name: "Uložit",
                      type: "btn-success"
                    }, null, 8, ["loading"])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_SideBar),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_LoadingOverlay, { loading: _ctx.loading }, null, 8, ["loading"]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_ctx.companies)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.companies, (company) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_Company, {
                    company: company,
                    onOnRemoved: _ctx.onRemoved,
                    onOnChangedPrimary: _ctx.onChangedPrimary
                  }, null, 8, ["company", "onOnRemoved", "onOnChangedPrimary"])
                ]))
              }), 256))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.modalAddHandleOpen && _ctx.modalAddHandleOpen(...args))),
              style: {"min-height":"101px"},
              class: "rounded-3 p-4 text-center border-0 w-100 h-100 bg-secondary bg-opacity-10 text-secondary"
            }, _hoisted_13)
          ])
        ])
      ])
    ])
  ], 64))
}